import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { AiOutlineEye } from "react-icons/ai";
import { AiOutlineEyeInvisible} from "react-icons/ai";
import RegesterNav from '../components/navber/RegesterNav';

const RegesterPage = () => {

  const [phone, setphone] = useState("")
  const [confrimphone, setconfrimphone] = useState("")
  const [name, setname] = useState("")
  const [Surnames, setSurnames] = useState("")
  const [password, setpassword] = useState("")
  const [confrimpassword, setconfrimpassword] = useState("")
  const [state,setState] = useState(false)
  const [state1,setState1] = useState(false)
  const navigate = useNavigate()


  const handelSubmit = (e)=>{
      e.preventDefault();
      navigate("/profile")

  }


  const trogalButton=(e)=>{
    e.preventDefault();
    setState(prevState=>!prevState)
  }
  const trogalButton1=(e)=>{
    e.preventDefault();
    setState1(prevState=>!prevState)
  }

  return (
    <>
    <RegesterNav/>
    <div className='pt-[120px]'>
        <div className="container">
            <div>
                <div className='headding mb-8'>
                    <h2 className='md:text-[59px] text-[32px] md:leading-[81px] leading-[37px] font-bold'>¡Felicidades! estás un paso más cerca
                      de terminar tu registro</h2>
                </div>

                <div className='max-w-[1100px] m-auto'>
                    <form action="" onSubmit={handelSubmit}>
                            <div  className='flex items-center flex-col md:flex-row gap-0  md:gap-[100px] w-full'>
                            <div className='w-full'>
                            <div className='py-2'>
                                <label htmlFor='phone' className='ml-5 text-[20px]'>Número celular</label>
                                <input type="text" id='phone' className='input_Box text-[20px] w-full py-2 px-2' value={phone} onChange={(e)=>setphone(e.target.value)} />
                            </div>
                            <div className='py-2'>
                                <label htmlFor='Nombres' className='ml-5 text-[20px]'>Nombres</label>
                                <input type="text" id='Nombres' className='input_Box text-[20px] w-full py-2 px-2' value={name} onChange={(e)=>setname(e.target.value)} />
                            </div>
                            <div className='py-2'>
                                <label htmlFor='Contraseña' className='ml-5 text-[20px]'>Contraseña</label>
                                <div className=' relative'>
                                <input type={`${state?"text" : "password"}`} id='Contraseña' className='input_Box text-[20px] w-full py-2 px-2' value={password} onChange={(e)=>setpassword(e.target.value)} />
                                <button className="text-[24px] absolute right-[10px] top-[30%]" onClick={trogalButton}>{
                                    state? <AiOutlineEye /> : <AiOutlineEyeInvisible />
                                }</button>
                                </div>
                            </div>
                        </div>
                        <div className='w-full'>
                        <div className='py-2'>
                                <label htmlFor='phone' className='ml-5 text-[20px]'>Confirmar número celular</label>
                                <input type="text" id='phone' className='input_Box text-[20px] w-full py-2 px-2' value={confrimphone} onChange={(e)=>setconfrimphone(e.target.value)} />
                            </div>
                            <div className='py-2'>
                                <label htmlFor='Nombres' className='ml-5 text-[20px]'>Apellidos</label>
                                <input type="text" id='Nombres' className='input_Box text-[20px] w-full py-2 px-2' value={Surnames} onChange={(e)=>setSurnames(e.target.value)} />
                            </div>
                            <div className='py-2'>
                                <label htmlFor='Contraseña' className='ml-5 text-[20px]'>Confirmar contraseña</label>
                                <div className=' relative'>
                                <input type={`${state1?"text" : "password"}`} id='Contraseña' className='input_Box text-[20px] w-full py-2 px-2' value={confrimpassword} onChange={(e)=>setconfrimpassword(e.target.value)} />
                                <button className="text-[24px] absolute right-[10px] top-[30%]" onClick={trogalButton1}>{
                                    state1? <AiOutlineEye /> : <AiOutlineEyeInvisible />
                                }</button>
                                </div>
                            </div>
                        </div>
                            </div>

                        <div className='flex items-start flex-col md:flex-row gap-2 justify-between mt-7'>
                            <div>
                                <div className='flex items-center gap-5'>
                                     <input type="checkbox" id='chke' className='chakbox' />
                                    <label className='md:text-[24px] w-[80%] lg:w-full text-[14px] font-normal' htmlFor="chke">He leído el <Link className='  border-b border-gray-400' to={"/"}>aviso de privacidad</Link> y acepto los <Link className='  border-b border-gray-400' to={"/"}>términos y condiciones</Link></label>
                                </div>
                                <p className='md:text-[24px] text-[14px] font-normal text-center mt-5'>¿Ya tienes cuenta? <Link className='  border-b border-gray-400' to={"/login"}>Iniciar sesión</Link></p>
                            </div>
                            <div>
                                <button type='submit' className='py-4 px-5 bg-[#4285F4] text-white text-[14px] font-medium rounded-md md:text-[24px]'>Regístrate</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
    </>
  )
}

export default RegesterPage